var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpanceClaimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.505,
    height: 16.5,
    viewBox: "0 0 15.505 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.748 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M3.907,5.209a.542.542,0,0,1-.365.664A3.756,3.756,0,0,1,2.619,6a2.137,2.137,0,0,1-.607-.082,1.176,1.176,0,0,0-.384-.051,3.735,3.735,0,0,0-.824.1.532.532,0,0,1-.588-.26.557.557,0,0,1,.093-.645A2.829,2.829,0,0,0,1,3.634L1,3.6H.427a.433.433,0,0,1,0-.867H.953L.935,2.653A.514.514,0,0,0,.9,2.564,1.954,1.954,0,0,1,1.6.293a1.762,1.762,0,0,1,2.229.24A.554.554,0,0,1,4,.907a.561.561,0,0,1-.136.392.509.509,0,0,1-.365.177.545.545,0,0,1-.384-.139A.731.731,0,0,0,2.179,1.2a.852.852,0,0,0-.272,1.019,4.373,4.373,0,0,1,.124.494l.006.025h.916a.433.433,0,0,1,0,.867H2.068v.032a3.728,3.728,0,0,1-.31,1.126L1.74,4.8l.043.006a2.323,2.323,0,0,1,.551.095.9.9,0,0,0,.272.032,3.06,3.06,0,0,0,.65-.088.526.526,0,0,1,.4.051.421.421,0,0,1,.248.31Z",
    transform: "translate(5.003 7)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-12",
    d: "M4.838,0h4.33c1.109,0,.5,1.664.051,2.679L8.708,3.843,8.639,4A2.241,2.241,0,0,1,10,4.382,15.62,15.62,0,0,1,13.59,9.251a3.945,3.945,0,0,1,.386,2.2A3.754,3.754,0,0,1,10.4,15H3.6A3.754,3.754,0,0,1,.025,11.455a3.945,3.945,0,0,1,.386-2.2A15.62,15.62,0,0,1,4,4.382,2.241,2.241,0,0,1,5.367,4l-.08-.181-.5-1.14C4.34,1.664,3.728,0,4.838,0Z",
    transform: "translate(0.003)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-13",
    d: "M4.055,1H4A8.767,8.767,0,0,1,2.284.819,8.1,8.1,0,0,1,0,0H8A7.684,7.684,0,0,1,5.705.843,8.786,8.786,0,0,1,4.114,1Z",
    transform: "translate(3.007 3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpanceClaimIcon);
export default __webpack_public_path__ + "static/media/expance-claim-icon.4e16fc472f81e38a5adea97848a28326.svg";
export { ForwardRef as ReactComponent };